import { combineReducers } from '@reduxjs/toolkit'

import project from 'project_quote/data/ProjectSlice'
import assembly from 'pcb-assembly/data/AssemblySlice'
import fabrication from 'pcb-fabrication/data/FabricationSlice'
import bom from 'pcb-parts/slice/bomSlice'

const rootReducer = combineReducers({
  project,
  assembly,
  fabrication,
  bom,
});

export default rootReducer
